import React from 'react';
import useIsMobile from '../hooks/useIsMobile';

export default function Table({
  columns = [], data = [], mobileCard, keyField = 'id',
  loading = false, emptyMessage = 'لا توجد بيانات', onRowClick,
  style,
}) {
  const isMobile = useIsMobile();

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: 'var(--sp-4xl)', color: 'var(--color-text-secondary)' }}>
        جاري التحميل...
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div style={{
        textAlign: 'center',
        padding: 'var(--sp-4xl)',
        color: 'var(--color-text-light)',
        backgroundColor: 'var(--color-white)',
        borderRadius: 'var(--radius-md)',
        boxShadow: 'var(--shadow-md)',
      }}>
        {emptyMessage}
      </div>
    );
  }

  if (isMobile && mobileCard) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--sp-md)', ...style }}>
        {data.map((row) => (
          <div
            key={row[keyField]}
            onClick={() => onRowClick && onRowClick(row)}
            style={{
              backgroundColor: 'var(--color-white)',
              borderRadius: 'var(--radius-md)',
              padding: 'var(--sp-lg)',
              boxShadow: 'var(--shadow-sm)',
              ...(onRowClick ? { cursor: 'pointer' } : {}),
            }}
          >
            {typeof mobileCard === 'function' ? mobileCard(row) : (
              columns.map((col) => (
                <div key={col.key} style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '6px 0',
                  borderBottom: '1px solid var(--color-border-light)',
                  fontSize: 'var(--font-size-base)',
                }}>
                  <span style={{ color: 'var(--color-text-secondary)', fontWeight: '600' }}>{col.label}</span>
                  <span>{col.render ? col.render(row[col.key], row) : (row[col.key] ?? '—')}</span>
                </div>
              ))
            )}
          </div>
        ))}
      </div>
    );
  }

  return (
    <div style={{ overflowX: 'auto', borderRadius: 'var(--radius-md)', boxShadow: 'var(--shadow-md)', ...style }}>
      <table style={{
        width: '100%',
        borderCollapse: 'collapse',
        backgroundColor: 'var(--color-white)',
        fontSize: 'var(--font-size-base)',
      }}>
        <thead>
          <tr style={{ backgroundColor: 'var(--color-primary-light)' }}>
            {columns.map((col) => (
              <th
                key={col.key}
                style={{
                  padding: '12px 16px',
                  textAlign: 'right',
                  fontWeight: '600',
                  color: 'var(--color-primary)',
                  whiteSpace: 'nowrap',
                  fontSize: 'var(--font-size-sm)',
                  borderBottom: '2px solid var(--color-primary)',
                  ...(col.width ? { width: col.width } : {}),
                }}
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, idx) => (
            <tr
              key={row[keyField]}
              onClick={() => onRowClick && onRowClick(row)}
              style={{
                borderBottom: '1px solid var(--color-border-light)',
                backgroundColor: idx % 2 === 0 ? 'var(--color-white)' : 'var(--color-bg)',
                transition: 'background-color var(--transition-fast)',
                ...(onRowClick ? { cursor: 'pointer' } : {}),
              }}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = 'var(--color-primary-light)'; }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = idx % 2 === 0 ? 'var(--color-white)' : 'var(--color-bg)';
              }}
            >
              {columns.map((col) => (
                <td
                  key={col.key}
                  style={{
                    padding: '10px 16px',
                    color: 'var(--color-text)',
                    ...(col.cellStyle ? (typeof col.cellStyle === 'function' ? col.cellStyle(row[col.key], row) : col.cellStyle) : {}),
                  }}
                >
                  {col.render ? col.render(row[col.key], row) : (row[col.key] ?? '—')}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
